import React, { FC } from 'react';

import { Pagination, PaginationProps } from 'react-admin';

export const GeotrackingPagination: FC<PaginationProps> = props => {
  return <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;
};
